/**
 * Flipnovel 品牌 - Welfare 页面配置
 */
import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

const primaryGradient = brandTheme.primaryGradient || 'linear-gradient(90deg, #FF8A4C 0%, #FF5A36 100%)'

/**
 * Flipnovel 品牌特定主题配置
 */
export const theme = {
  // 按钮背景色
  btnBg: brandTheme.primaryColor,
  // 按钮文本颜色
  btnText: brandTheme.textInverse,
  // 金币颜色
  coinsColor: brandTheme.primaryColor,
  // 金币数量渐变色
  coinsGradient: primaryGradient,
  // 通用渐变色（任务按钮、弹窗按钮）
  actionGradient: brandTheme.primaryGradient,
  // Check-in 按钮渐变色
  checkinBtnGradient: primaryGradient,
} as const

/**
 * Flipnovel 品牌特定资源配置
 */
export const resources = {
  // 首页背景图
  homeBg: '/images/flipnovel/home-bg.webp',
  // 金币图标
  welfareGold: '/images/flipnovel/welfare-gold.png',
  // 宝箱图标
  welfareBox: '/images/flipnovel/welfare-box.png',
} as const

export const welfareConfig: WelfarePageConfig = {
  theme,
  resources,
  texts: welfareCommonConfig.texts,
}
